const data: any = {
  searchItemsHotUnderPriceBlock: {
    title: 'Hot under $40',
    blockName: 'Hot Under Price',
    subtitle:
      'Looking to stick to a budget? We have high-quality items at every price point.',
    cta: {
      title: 'Browse items under $40',
      urlSearchParams: {
        category: 'all',
        date: 'this-year',
        sort: 'sales',
        price_max: '39'
      }
    },
    data: [
      {
        id: 24689900,
        name: 'Pixwell - Modern Magazine',
        site: 'themeforest.net',
        classification: 'wordpress/blog-magazine/news-editorial',
        price_cents: 2900,
        number_of_sales: 1917,
        author_username: 'Theme-Ruby',
        author_url: 'https://themeforest.net/user/Theme-Ruby',
        url: 'https://themeforest.net/item/pixwell-modern-magazine/24689900',
        rating: {
          rating: 4.95,
          count: 75
        },
        updated_at: '2020-05-24T19:01:01+10:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/272097380/icon.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/281568389/01_preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/pixwell-modern-magazine/full_screen_preview/24689900'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/281568389/01_preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/281568389/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=dc9e330cf91b40481627358d8afbe4bf',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/281568389/02_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=de3b14d985d40d482dc200b9ec78fcae',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/281568389/03_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=3b22727b68d5d99c3a8ed7101f8df1c9',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/281568389/04_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f6ed91a94bcfa1d93bfab6edffb7246d',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/281568389/05_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=78f9ad771e94d674b1cdaec612f94f62',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 25582188,
        name: 'Cork - Responsive Admin Dashboard Template',
        site: 'themeforest.net',
        classification: 'site-templates/admin-templates',
        price_cents: 900,
        number_of_sales: 1708,
        author_username: 'designreset',
        author_url: 'https://themeforest.net/user/designreset',
        url:
          'https://themeforest.net/item/cork-responsive-admin-dashboard-template/25582188',
        rating: {
          rating: 4.88,
          count: 43
        },
        updated_at: '2020-05-26T07:31:17+10:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/279918979/logo.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/290008541/01_preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/cork-responsive-admin-dashboard-template/full_screen_preview/25582188'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/290008541/01_preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/290008541/01_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=67335bd523edd1c1f61dd2c1e8f8753f',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24207799,
        name: 'Jumpstart App and Software Template',
        site: 'themeforest.net',
        classification: 'site-templates/technology',
        price_cents: 1800,
        number_of_sales: 1676,
        author_username: 'medium_rare',
        author_url: 'https://themeforest.net/user/medium_rare',
        url:
          'https://themeforest.net/item/jumpstart-app-and-software-template/24207799',
        rating: {
          rating: 4.93,
          count: 29
        },
        updated_at: '2020-02-26T11:58:24+11:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/281993115/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/281993116/item-preview-image-normal.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/jumpstart-app-and-software-template/full_screen_preview/24207799'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/281993116/item-preview-image-normal.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/281993116/item-preview-image-normal.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=d4d381d0c1529d66df08d946d53ffd7d',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24304706,
        name: 'Newspaper News Magazine WordPress Theme - Digiqole',
        site: 'themeforest.net',
        classification: 'wordpress/blog-magazine/news-editorial',
        price_cents: 3500,
        number_of_sales: 1415,
        author_username: 'trippleS',
        author_url: 'https://themeforest.net/user/trippleS',
        url:
          'https://themeforest.net/item/digiqole-news-magazine-wordpress-theme/24304706',
        rating: {
          rating: 4.85,
          count: 53
        },
        updated_at: '2020-05-21T14:31:01+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/289683513/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/288549532/theme_preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/digiqole-news-magazine-wordpress-theme/full_screen_preview/24304706'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/288549532/theme_preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/288549532/theme_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=480bc7e87ab88147a7acd4ef520588e8',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      }
    ]
  },
  newBestSellers: {
    title: 'New bestsellers',
    blockName: 'New Bestsellers',
    subtitle:
      'Looking for something fresh? Browse the latest items to join our bestsellers list.',
    cta: {
      title: 'Browse new bestsellers',
      urlSearchParams: {
        category: 'all',
        date: 'this-year',
        sort: 'sales'
      }
    },
    data: [
      {
        id: 23714045,
        name: 'Ekko - Multi-Purpose WordPress Theme with Page Builder',
        site: 'themeforest.net',
        classification: 'wordpress/corporate/business',
        price_cents: 5900,
        number_of_sales: 2732,
        author_username: 'Key-Design',
        author_url: 'https://themeforest.net/user/Key-Design',
        url:
          'https://themeforest.net/item/ekko-multipurpose-wordpress-theme-with-page-builder/23714045',
        rating: {
          rating: 4.88,
          count: 57
        },
        updated_at: '2020-05-21T02:59:38+10:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/264030646/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/268162873/01_preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/ekko-multipurpose-wordpress-theme-with-page-builder/full_screen_preview/23714045'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/268162873/01_preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/268162873/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=18ced90175db377e5e9bdebc3eb552de',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 25193838,
        name: 'Ohio - Creative Portfolio & Agency WordPress Theme',
        site: 'themeforest.net',
        classification: 'wordpress/creative/portfolio',
        price_cents: 5900,
        number_of_sales: 2574,
        author_username: 'colabrio',
        author_url: 'https://themeforest.net/user/colabrio',
        url:
          'https://themeforest.net/item/ohio-creative-wordpress-theme/25193838',
        rating: {
          rating: 4.94,
          count: 71
        },
        updated_at: '2020-05-07T22:02:16+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/288628484/thumbnail__80x80__v1.1.0.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/288628485/01_preview_590x300.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/ohio-creative-wordpress-theme/full_screen_preview/25193838'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/288628485/01_preview_590x300.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/288628485/01_preview_590x300.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=b65e0a6abb7eb49130b62203e18b1362',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 23850621,
        name: 'Webify – All-in-One Elementor WordPress Theme',
        site: 'themeforest.net',
        classification: 'wordpress/corporate/business',
        price_cents: 5900,
        number_of_sales: 1437,
        author_username: 'theme_bubble',
        author_url: 'https://themeforest.net/user/theme_bubble',
        url:
          'https://themeforest.net/item/webify-allinone-responsive-wordpress-theme/23850621',
        rating: {
          rating: 4.86,
          count: 49
        },
        updated_at: '2020-05-01T01:58:41+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/265161050/thumb.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/267442981/preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/webify-allinone-responsive-wordpress-theme/full_screen_preview/23850621'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/267442981/preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/267442981/preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=e842126eb5c46922c4d67393b7016923',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24849892,
        name: 'Sitka - Modern WordPress Blog Theme',
        site: 'themeforest.net',
        classification: 'wordpress/blog-magazine/personal',
        price_cents: 5900,
        number_of_sales: 1359,
        author_username: 'SoloPine',
        author_url: 'https://themeforest.net/user/SoloPine',
        url:
          'https://themeforest.net/item/sitka-modern-wordpress-blog-theme/24849892',
        rating: {
          rating: 5,
          count: 20
        },
        updated_at: '2020-05-07T19:42:48+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/276657008/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/276657009/01_Preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/sitka-modern-wordpress-blog-theme/full_screen_preview/24849892'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/276657009/01_Preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/276657009/01_Preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=416e02ac59d2f622b64da9dcfa53b090',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      }
    ]
  },
  searchItemsRotatingTagBlock: {
    title: 'Top portfolio items',
    blockName: 'Top Tag Items',
    subtitle:
      'Whether you’re a freelancer, agency, photographer or architect, you’ll find a portfolio theme to suit your needs and style.',
    cta: {
      title: 'Browse portfolio themes',
      urlSearchParams: {
        category: 'all',
        date: 'this-year',
        sort: 'sales',
        tags: 'portfolio'
      }
    },
    data: [
      {
        id: 24226512,
        name: 'Brook - Creative Agency & Business HTML Template',
        site: 'themeforest.net',
        classification: 'site-templates/creative/portfolio',
        price_cents: 1200,
        number_of_sales: 1282,
        author_username: 'BootXperts',
        author_url: 'https://themeforest.net/user/BootXperts',
        url:
          'https://themeforest.net/item/brook-creative-agency-business-html-template/24226512',
        rating: {
          rating: 3.95,
          count: 22
        },
        updated_at: '2020-04-27T03:18:23+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/268283649/brook_thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/268283650/01_preview_brook.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/brook-creative-agency-business-html-template/full_screen_preview/24226512'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/268283650/01_preview_brook.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/268283650/01_preview_brook.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=6501da8c473a2855f27349d7d4d5b3de',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24219257,
        name: 'BLO - Corporate Business WordPress Theme',
        site: 'themeforest.net',
        classification: 'wordpress/corporate/business',
        price_cents: 2500,
        number_of_sales: 1281,
        author_username: 'XpeedStudio',
        author_url: 'https://themeforest.net/user/XpeedStudio',
        url:
          'https://themeforest.net/item/blo-corporate-business-wordpress-theme/24219257',
        rating: {
          rating: 4.87,
          count: 30
        },
        updated_at: '2020-05-07T22:07:04+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/268981548/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/277212329/preview/00_preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/blo-corporate-business-wordpress-theme/full_screen_preview/24219257'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/277212329/preview/00_preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/277212329/preview/00_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=5e3f3e1b284e2e9db7a7c1187c084a1c',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/277212329/preview/01_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=68e904f1bbff1438e94c73da37a896af',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/277212329/preview/02_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=562ceb331cf618081c0a50a1d31ea08c',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/277212329/preview/03_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=54dea7725b296403b42fbf65f121dd98',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/277212329/preview/04_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=a77a9ed8e16b987d01efa39a24b2d703',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 20527137,
        name: 'Navian - Multi-Purpose Responsive WordPress Theme',
        site: 'themeforest.net',
        classification: 'wordpress/corporate/business',
        price_cents: 1700,
        number_of_sales: 1080,
        author_username: 'THEMELOGI',
        author_url: 'https://themeforest.net/user/THEMELOGI',
        url:
          'https://themeforest.net/item/navian-responsive-multipurpose-wordpress-theme/20527137',
        rating: {
          rating: 4.77,
          count: 22
        },
        updated_at: '2020-05-12T02:03:50+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/289010374/thumbnail17.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/289010375/01_preview_17.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/navian-responsive-multipurpose-wordpress-theme/full_screen_preview/20527137'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/289010375/01_preview_17.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/289010375/01_preview_17.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=128b3cb26ab48912b3d61990cb3bf6b5',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24907820,
        name: 'Trax - One Page Parallax',
        site: 'themeforest.net',
        classification: 'site-templates/corporate/business',
        price_cents: 1400,
        number_of_sales: 907,
        author_username: 'themesindustry',
        author_url: 'https://themeforest.net/user/themesindustry',
        url: 'https://themeforest.net/item/trax-one-page-parallax/24907820',
        rating: {
          rating: 5,
          count: 10
        },
        updated_at: '2019-10-24T03:35:21+11:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/274125425/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/274125426/01_theme-preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/trax-one-page-parallax/full_screen_preview/24907820'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/274125426/01_theme-preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/274125426/01_theme-preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=84d385d6767ae992815d0dd284806ba1',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      }
    ]
  },
  searchItemsRotatingSubcategoryBlock: {
    title: 'Top Adobe Muse themes & Muse templates',
    blockName: 'Top Subcategory Items',
    subtitle:
      "Choose from over 1,000 Adobe Muse themes & Muse templates. Explore items created by our global community of independent designers and developers, confident they're hand-reviewed by us.",
    cta: {
      title: 'Browse muse themes & templates',
      urlSearchParams: {
        category: 'muse-templates',
        date: 'this-year',
        sort: 'sales'
      }
    },
    data: [
      {
        id: 24234606,
        name: 'AIR - Minimal Portfolio Muse Template',
        site: 'themeforest.net',
        classification: 'muse-templates/creative',
        price_cents: 2100,
        number_of_sales: 24,
        author_username: 'JuliaPovarkova',
        author_url: 'https://themeforest.net/user/JuliaPovarkova',
        url:
          'https://themeforest.net/item/air-minimal-portfolio-muse-template/24234606',
        rating: {
          rating: 0,
          count: 0
        },
        updated_at: '2019-08-19T21:28:53+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/269738132/Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/269738133/Preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/air-minimal-portfolio-muse-template/full_screen_preview/24234606'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/269738133/Preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/269738133/Preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=7e410461657e2eb6c750f2c09db67331',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24495208,
        name: 'RISE - Creative Muse Template',
        site: 'themeforest.net',
        classification: 'muse-templates/creative',
        price_cents: 2100,
        number_of_sales: 24,
        author_username: 'JuliaPovarkova',
        author_url: 'https://themeforest.net/user/JuliaPovarkova',
        url:
          'https://themeforest.net/item/rise-creative-muse-template/24495208',
        rating: {
          rating: 0,
          count: 1
        },
        updated_at: '2019-09-10T00:30:48+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/270588065/Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/270588066/Preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/rise-creative-muse-template/full_screen_preview/24495208'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/270588066/Preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/270588066/Preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=03d77f8a5179cb1689026f8fec319e5d',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 25518958,
        name: 'Siven - Adobe Muse Template',
        site: 'themeforest.net',
        classification: 'muse-templates/creative',
        price_cents: 2100,
        number_of_sales: 16,
        author_username: 'Nublislabs',
        author_url: 'https://themeforest.net/user/Nublislabs',
        url: 'https://themeforest.net/item/siven-adobe-muse-template/25518958',
        rating: {
          rating: 0,
          count: 1
        },
        updated_at: '2020-01-23T05:16:57+11:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/279859029/siven_thumbnail.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/279859030/Preview/01_preview_Siven.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/siven-adobe-muse-template/full_screen_preview/25518958'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/279859030/Preview/01_preview_Siven.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/279859030/Preview/01_preview_Siven.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=db28218f462bef451822b6a94abf9ae0',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 24605814,
        name: 'WIND - Photography Muse Template',
        site: 'themeforest.net',
        classification: 'muse-templates/creative',
        price_cents: 2100,
        number_of_sales: 8,
        author_username: 'JuliaPovarkova',
        author_url: 'https://themeforest.net/user/JuliaPovarkova',
        url:
          'https://themeforest.net/item/wind-photography-muse-template/24605814',
        rating: {
          rating: 0,
          count: 0
        },
        updated_at: '2019-09-19T00:15:41+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/271836544/Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/271836545/Preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/wind-photography-muse-template/full_screen_preview/24605814'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/271836545/Preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/271836545/Preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=352c2ac6790dc10c36399a6ce310736c',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      }
    ]
  },
  upAndComing: {
    title: 'Rising stars',
    blockName: 'Top Subcategory Items',
    subtitle:
      'Browse our bestselling themes and templates added this month by our global community of independent designers and developers.',
    cta: {
      title: 'Browse rising stars',
      urlSearchParams: {
        category: 'all',
        date: 'this-month',
        sort: 'sales'
      }
    },
    data: [
      {
        id: 26538545,
        name: 'Medizin - Medical Elementor WooCommerce Theme',
        site: 'themeforest.net',
        classification: 'wordpress/ecommerce/woocommerce',
        price_cents: 4900,
        number_of_sales: 139,
        author_username: 'ThemeMove',
        author_url: 'https://themeforest.net/user/ThemeMove',
        url:
          'https://themeforest.net/item/medizin-medical-woocommerce-theme/26538545',
        rating: {
          rating: 5,
          count: 4
        },
        updated_at: '2020-05-13T17:27:42+10:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/290035379/Thumb%20intro.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/289179601/Preview-medizin-intro%20.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/medizin-medical-woocommerce-theme/full_screen_preview/26538545'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/289179601/Preview-medizin-intro%20.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/289179601/Preview-medizin-intro+.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=47e2b4d673ac58f2bf25ffbadf62a781',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 26501947,
        name: 'Poco - HTML & Laravel Admin Dashboard Template',
        site: 'themeforest.net',
        classification: 'site-templates/admin-templates',
        price_cents: 900,
        number_of_sales: 112,
        author_username: 'PixelStrap',
        author_url: 'https://themeforest.net/user/PixelStrap',
        url:
          'https://themeforest.net/item/poco-responsive-admin-dashboard-template/26501947',
        rating: {
          rating: 4.8,
          count: 5
        },
        updated_at: '2020-05-26T16:47:53+10:00',
        trending: false,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/290952911/icon.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/290952912/01_banner.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/poco-responsive-admin-dashboard-template/full_screen_preview/26501947'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/290952912/01_banner.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/290952912/01_banner.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=1636a9b24da5f4b60c7349463fdd17d5',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 26645744,
        name: 'Valex -  Bootstrap Admin Dashboard HTML Template',
        site: 'themeforest.net',
        classification: 'site-templates/admin-templates',
        price_cents: 500,
        number_of_sales: 104,
        author_username: 'SprukoSoft',
        author_url: 'https://themeforest.net/user/SprukoSoft',
        url:
          'https://themeforest.net/item/valex-bootstrap-admin-dashboard-html-template/26645744',
        rating: {
          rating: 5,
          count: 3
        },
        updated_at: '2020-05-24T03:48:40+10:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/290628132/Thumbnail.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/290628133/Theme_Preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/valex-bootstrap-admin-dashboard-html-template/full_screen_preview/26645744'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/290628133/Theme_Preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/290628133/Theme_Preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=4cb670a3c7c8fcd567bafe418903a694',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      },
      {
        id: 26372986,
        name: 'Homeo - Real Estate WordPress Theme',
        site: 'themeforest.net',
        classification: 'wordpress/real-estate',
        price_cents: 3900,
        number_of_sales: 101,
        author_username: 'ApusTheme',
        author_url: 'https://themeforest.net/user/ApusTheme',
        url:
          'https://themeforest.net/item/homeo-real-estate-wordpress-theme/26372986',
        rating: {
          rating: 5,
          count: 5
        },
        updated_at: '2020-05-21T15:02:08+10:00',
        trending: true,
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/287882996/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/287882997/preview/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/homeo-real-estate-wordpress-theme/full_screen_preview/26372986'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/287882997/preview/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/287882997/preview/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=1346b93838d47e8bfa08d836ca1a542c',
                width: 590,
                height: 300
              }
            ]
          }
        },
        ui: {
          isInBookmarks: false,
          isInFavourites: false
        }
      }
    ]
  }
}

export default data
